module.exports = __webpack_public_path__ + "img/Ebay.0e1fdfa1.jpg";